module.exports = __webpack_public_path__ + "static/media/logo_epa_rvb_bleu_turquoise.e1c02315.png";